export default "__VITE_PUBLIC_ASSET__a2fcacb5__"